import React from 'react';
export var NumberInputVariant;
(function (NumberInputVariant) {
    NumberInputVariant[NumberInputVariant["Info"] = 0] = "Info";
    NumberInputVariant[NumberInputVariant["Success"] = 1] = "Success";
    NumberInputVariant[NumberInputVariant["Warning"] = 2] = "Warning";
    NumberInputVariant[NumberInputVariant["Error"] = 3] = "Error";
})(NumberInputVariant || (NumberInputVariant = {}));
export class NumberInput extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            let colorStyle = '';
            let tipStyle = '';
            switch (this.props.variant) {
                case NumberInputVariant.Success:
                    colorStyle =
                        'border-green-700 hover:border-green-600 focus:border-green-700 focus:shadow-outline-green-700';
                    tipStyle = 'text-green-500';
                    break;
                case NumberInputVariant.Warning:
                    colorStyle =
                        'border-yellow-500 hover:border-yellow-400 focus:border-yellow-500 focus:shadow-outline-yellow-500';
                    tipStyle = 'text-yellow-500';
                    break;
                case NumberInputVariant.Error:
                    colorStyle = 'border-red-700 hover:border-red-600 focus:border-red-700 focus:shadow-outline-red-700';
                    tipStyle = 'text-red-500';
                    break;
                case NumberInputVariant.Info:
                default:
                    colorStyle =
                        'border-base-600 hover:border-primary-500 focus:border-primary-600 focus:shadow-outline-primary-600';
                    tipStyle = 'text-base-400';
                    break;
            }
            if (this.props.disabled) {
                colorStyle = 'border-base-600';
                tipStyle = 'text-base-400';
            }
            if (this.props.readOnly) {
                colorStyle = 'border-base-600';
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("label", { className: `${this.props.className} inline-block`, style: this.props.style },
                    React.createElement("span", { className: 'block text-sm text-base-400' }, this.props.label),
                    React.createElement("div", { className: 'relative' },
                        React.createElement("input", { defaultValue: this.props.defaultValue, value: this.props.value, type: 'number', min: this.props.min, max: this.props.max, step: this.props.step, placeholder: this.props.placeholder, disabled: this.props.disabled, readOnly: this.props.readOnly, onChange: this.props.onChange, className: `block w-full mt-1 px-2 py-2 ${this.props.icon ? 'pl-10' : ''} text-sm text-base-300 bg-base-700 border-1 rounded ${colorStyle} focus:outline-none transition-colors duration-150` }),
                        React.createElement("div", { className: `flex items-center ml-3 absolute inset-y-0 text-base-400 pointer-events-none` }, this.props.icon)),
                    React.createElement("span", { className: `block ${typeof this.props.tip === 'string' ? 'h-4' : ''} m-1 text-xs ${tipStyle}` }, this.props.tip))));
        };
    }
}
